import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-animate_triangle",
  "use": "icon-animate_triangle-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-animate_triangle\">\n<path d=\"M15.5382 9.26665C15.7434 8.91112 16.2566 8.91112 16.4619 9.26665L22.9278 20.4659C23.133 20.8215 22.8764 21.2659 22.4659 21.2659H9.53409C9.12356 21.2659 8.86698 20.8215 9.07224 20.4659L15.5382 9.26665Z\" stroke=\"#81818A\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol